import { defineComponent, h } from 'vue';

export const SlideRightTransition = defineComponent({
  setup(_, context) {
    return function render() {
      return h('transition', {
        props: {
          enterActiveClass: 'animate__animated animate__slideInRight animate__faster',
          leaveActiveClass: 'animate__animated animate__slideOutRight animate__faster',
          mode: 'out-in',
        },
      }, context.slots.default?.());
    };
  },
});
